import cx from 'classnames';

import styles from './Spinner.module.scss';

export type TSpinnerProps = {
  className?: string;
};

export const Spinner = ({ className = '' }: TSpinnerProps) => {
  return <div className={cx(styles.spinner, className)} />;
};
